'use client';

import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'react';

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  spinnerClassName?: string;
}

export function Spinner({
  className,
  spinnerClassName,
  size = 'md',
  ...props
}: SpinnerProps) {
  return (
    <div
      className={cn(
        'relative inline-block',
        size === 'sm' && 'h-3 w-3',
        size === 'md' && 'h-4 w-4',
        size === 'lg' && 'h-6 w-6',
        className,
      )}
      {...props}
    >
      {Array.from({ length: 12 }).map((_, i) => (
        <div
          key={i}
          className={cn('spinner-blade', 'bg-foreground', spinnerClassName)}
        />
      ))}
    </div>
  );
}
